import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Paper,
  FormControlLabel,
  FormGroup,
  Checkbox,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  Tab,
  Tabs,
  List,
  ListItem,
  ListItemText,
  Switch,
  Chip,
  IconButton,
  Alert,
  OutlinedInput,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import {
  getAppConfig,
  clearMessage,
  updateConfigRequest,
  getBenefitsAndFeatures,
} from "../../../redux/Configuration/configurationSlice";
import Sidebar from "../../Drawer/Sidebar";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import Reusable from "./Reusables";
import { takeLatest, put, call } from "redux-saga/effects";
import { CurrencyList } from "../../../configs/constants";
import { canShowPermission } from "../Permissions/permissionObject";
import { useTranslation } from "react-i18next";
import auth from "../../../configs/auth";
import { getActiveCountriesRequest } from "../../../redux/CountryList/CountrySlice";
import {
  getSettingsRequest,
  savePaymentGatewayCountriesRequest,
} from "../../../redux/settings/settingsSlice";

const AppConfig = () => {
  const TAX_APPLICATION_MODES = {
    SGST_CGST: "SGST_CGST",
    IGST: "IGST",
    STATE_WISE: "STATE_WISE",
  };
  const VALID_TAX_APPLICATION_MODES = Object.values(TAX_APPLICATION_MODES);
  const TAX_APPLICATION_MODE_DESCRIPTIONS = [
    "SGST_CGST: Always apply SGST + CGST",
    "IGST: Always apply IGST",
    "STATE_WISE: Same state -> SGST+CGST, Different state -> IGST",
  ];

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const message = useSelector((state) => state?.AppConfig?.message);
  const error = useSelector((state) => state?.AppConfig?.error);
  const configData = useSelector((state) => state?.appConfig?.configData || {});
  const benefitsData = useSelector(
    (state) => state?.appConfig?.benefitsAndFeatures?.benefitFields || [],
  );
  const featuresData = useSelector(
    (state) => state?.appConfig?.benefitsAndFeatures?.FeatureOptions || {},
  );
  const { activeCountries = [] } = useSelector((state) => state.country || {});
  const settingsData = useSelector((state) => state.settingData?.data);

  const rawBankList = useSelector(
    (state) => state?.appConfig?.configData?.bankList || [],
  );

  useEffect(() => {
    const normalize = (v) => v.toLowerCase().replace(/\s/g, "");
    setPaymentGateways((prev) => Array.from(new Set(prev.map(normalize))));
  }, []);

  useEffect(() => {
    if (configData?.paymentGateways) {
      const normalize = (v) => v.toLowerCase().replace(/\s/g, "");
      const validOptions = optionsGateway.map(normalize);

      const cleaned = configData.paymentGateways
        .map(normalize)
        .filter((v) => validOptions.includes(v));

      setPaymentGateways(cleaned);
    }
  }, [configData]);

  const [enableSellViaUPI, setEnableSellViaUPI] = useState(false);
  const handleSaveEnableSellViaUPI = () => {
    dispatch(
      updateConfigRequest({
        key: "enableSellViaUPI",
        value: enableSellViaUPI ? true : false,
      }),
    );
  };

  const [showCalculatedAmountInRedeem, setShowCalculatedAmountInRedeem] =
    useState(false);
  const handleSaveShowCalculatedAmountInRedeem = () => {
    dispatch(
      updateConfigRequest({
        key: "showCalculatedAmountInRedeem",
        value: showCalculatedAmountInRedeem ? true : false,
      }),
    );
  };

  const [autoDebit, setAutoDebit] = useState(false);
  const handleAutoDebit = () => {
    dispatch(
      updateConfigRequest({
        key: "autoDebit",
        value: autoDebit ? true : false,
      }),
    );
  };

  const [referralRequiredRegistration, setReferralRequiredRegistration] =
    useState(false);
  const handleSaveReferralRequiredRegistration = () => {
    dispatch(
      updateConfigRequest({
        key: "referralRequiredRegistration",
        value: referralRequiredRegistration ? true : false,
      }),
    );
  };

  const [middleNameEnabled, setMiddleNameEnabled] =
    useState(false);
  const handleSaveMiddleName = () => {
    dispatch(
      updateConfigRequest({
        key: "middleNameEnabled",
        value: middleNameEnabled ? true : false,
      }),
    );
  };
  const [offlinePaymentType, setOfflinePaymentType] = useState({
    store: true,
    home: true,
  });
  const handleSaveOfflinePaymentType = () => {
    if (!offlinePaymentType.store && !offlinePaymentType.home) {
      toast.error("At least one offline payment type (Home or Store) must be selected");
      return;
    } 

    dispatch(
      updateConfigRequest({
        key: "offlinePaymentType",
        value: {
          store: offlinePaymentType.store === true,
          home: offlinePaymentType.home === true,
        },
      }),
    );
  };

  const [jewellerAppStatus, setJewellerAppStatus] = useState({
    ios: false,
    android: false,
  });
  const handleJewellerAppStatus = (platform, checked) => {
    setJewellerAppStatus((current) => ({
      ...current,
      [platform]: checked,
    }));
    dispatch(
      updateConfigRequest({
        key: "jewellerAppStatus",
        value: { [platform]: checked },
      }),
    );
  };

  const bankLists =
    rawBankList && typeof rawBankList === "string"
      ? rawBankList
          .split(",")
          .map((b) => b.trim())
          .filter(Boolean)
      : Array.isArray(rawBankList)
        ? rawBankList
        : [];

  const [offlineDetails, setOfflineDetails] = useState({
    bankName: "",
    accountNumber: "",
    ifscCode: "",
    sortCode: "",
    upiId: "",
    qrCodeUrl: "",
  });
  const [qrCodeFile, setQrCodeFile] = useState(null);
  const [removeQr, setRemoveQr] = useState(false);
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const selectedJewellerId =
    sessionStorage.getItem(auth.selectedJeweller) || "";
  const finalJewellerId =
    selectedJewellerId && selectedJewellerId.trim() !== ""
      ? selectedJewellerId
      : storedUser?.jeweller;

  const handleOfflinePaymentSave = async () => {
    const { bankName, accountNumber, ifscCode, sortCode, upiId, qrCodeUrl } =
      offlineDetails;

    // if (!accountNumber) {
    //   toast.error("Account Number is required");
    //   return;
    // }

    // if (!ifscCode) {
    //   toast.error("IFSC Code is required");
    //   return;
    // }

    // if (!upiId) {
    //   toast.error("UPI ID is required");
    //   return;
    // }

    // if (!qrCodeUrl) {
    //   toast.error("QR Code Image is required");
    //   return;
    // }

    const isAnyFieldFilled =
      bankName ||
      accountNumber ||
      ifscCode ||
      sortCode ||
      upiId ||
      qrCodeUrl ||
      removeQr;
    if (!isAnyFieldFilled) {
      toast.error("At least one option must be filled");
      return;
    }

    if (
      typeof qrCodeUrl === "string" &&
      qrCodeUrl.startsWith("blob:") &&
      !qrCodeFile
    ) {
      toast.error("Please reselect QR image before saving");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("jeweller", finalJewellerId || "");
      formData.append("bankName", bankName || "");
      formData.append("accountNo", accountNumber || "");
      formData.append("accountNumber", accountNumber || "");
      formData.append("ifscCode", ifscCode || "");
      formData.append("sortCode", sortCode || "");
      formData.append("upiId", upiId || "");

      if (qrCodeFile) {
        formData.append("qr", qrCodeFile);
      } else if (removeQr) {
        formData.append("removeQr", "true");
        formData.append("qrCodeUrl", "");
      } else if (qrCodeUrl && !qrCodeUrl.startsWith("blob:")) {
        formData.append("qrCodeUrl", qrCodeUrl);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/addPaymentDetails`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const savedQrCodeUrl =
        response?.data?.data?.qr || response?.data?.qr || qrCodeUrl;

      setOfflineDetails((prev) => ({
        ...prev,
        qrCodeUrl: savedQrCodeUrl,
      }));
      setQrCodeFile(null);
      setRemoveQr(false);
      dispatch(getAppConfig());
      toast.success(
        response?.data?.message || "Payment details saved successfully",
      );
    } catch (error) {
      const message =
        error?.response?.data?.message || "Failed to save payment details";
      toast.error(message);
    }
  };

  const [currency, setCurrency] = useState("INR");
  const [appMode, setAppMode] = useState("PROD");
  const [termsAndConditionsUrl, setTermsAndConditionsUrl] = useState("");
  const [featureToggle, setFeatureToggle] = useState(featuresData);
  const [benefits, setBenefits] = useState(benefitsData ?? []);
  const [lookbookText, setLookbookText] = useState("Explore Designs");
  const [bankName, setBankName] = useState("");
  const [bankList, setBankList] = useState([]);
  const [cdnUrl, setCdnUrl] = useState("");
  const [buyTextLabel, setBuyTextLabel] = useState("");
  const [convenienceFeeSell, setConvenienceFeeSell] = useState(0);
  const [paymentGateways, setPaymentGateways] = useState([]);
  const [paymentGatewayForCountries, setPaymentGatewayForCountries] =
    useState("");
  const [paymentGatewayCountryIds, setPaymentGatewayCountryIds] = useState([]);
  const [paymentGatewayCountriesList, setPaymentGatewayCountriesList] =
    useState([]);
  const [decimalPrecision, setDecimalPrecision] = useState(0);
  const [mobileNumberLength, setMobileNumberLength] = useState(0);
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [extWhatsappBaseUrl, setExtWhatsappBaseUrl] = useState();
  const [extWhatsappApiKey, setExtWhatsappApiKey] = useState("");
  const [infobipSmsBaseUrl, setInfobipSmsBaseUrl] = useState(
    "https://55m1pg.api.infobip.com",
  );
  const [infobipSmsApiKey, setInfobipSmsApiKey] = useState("");
  const [infobipSmsUsSender, setInfobipSmsUsSender] = useState("");
  const [paymentModeEnabled, setPaymentModeEnabled] = useState({
    online: false,
    offline: false,
  });
  const [sipPaymentModeEnabled, setSipPaymentModeEnabled] = useState({
    online: false,
    offline: false,
  });
  const [appLinks, setAppLinks] = useState({
    androidAppLink: "",
    iosAppLink: "",
    oneLink: "",
  });
  const [taxType, setTaxType] = useState("GST");
  const [taxApplicationMode, setTaxApplicationMode] = useState(
    TAX_APPLICATION_MODES.STATE_WISE,
  );
  const [taxApplicationModeError, setTaxApplicationModeError] = useState("");
  const [isBuyGstEnabled, setIsBuyGstEnabled] = useState(true);
  const [isSipInstallmentGstEnabled, setIsSipInstallmentGstEnabled] =
    useState(true);
  const [isGiftGstEnabled, setIsGiftGstEnabled] = useState(true);

  const handleSaveTaxType = () => {
    dispatch(
      updateConfigRequest({
        key: "taxtype",
        value: taxType,
      }),
    );
  };
  const handleSaveTaxApplicationMode = () => {
    if (!VALID_TAX_APPLICATION_MODES.includes(taxApplicationMode)) {
      setTaxApplicationModeError("Please select a valid tax application mode");
      return;
    }

    setTaxApplicationModeError("");
    dispatch(
      updateConfigRequest({
        key: "taxApplicationMode",
        value: taxApplicationMode,
      }),
    );
  };

  const handleSaveModuleGstToggle = (key, value) => {
    dispatch(
      updateConfigRequest({
        key,
        value: value ? true : false,
      }),
    );
  };

  useEffect(() => {
    if (!configData || !configData.bankList) {
      setBankList([]);
      return;
    }

    let list = configData.bankList;

    if (typeof list === "string") {
      list = list
        .split(",")
        .map((b) => b.trim())
        .filter(Boolean);
    }

    if (!Array.isArray(list)) {
      list = [];
    }

    setBankList(list);
  }, [configData]);

  const handelSetBankList = () => {
    const trimmed = bankName.trim();
    if (!trimmed) {
      toast.error("Bank name is required");
      return;
    }

    if (bankList.includes(trimmed)) {
      toast.error("Bank already exists");
      return;
    }
    if (!trimmed || bankList.includes(trimmed)) return;

    const updated = [...bankList, trimmed];
    setBankList(updated);
    setBankName("");

    dispatch(
      updateConfigRequest({
        key: "bankList",
        value: updated,
      }),
    );
  };

  const saveConfig = (key, value) => {
    dispatch(updateConfigRequest({ key, value }));
  };

  const handleSaveWhatsAppNo = () => {
    if (!whatsappNumber) {
      toast.error("WhatsApp number cannot be empty");
      return;
    }
    if (!/^[6-9][0-9]{9}$/.test(whatsappNumber)) {
      toast.error("Please enter a valid 10-digit WhatsApp number");
      return;
    }
    dispatch(
      updateConfigRequest({ key: "whatsappNumber", value: whatsappNumber }),
    );
  };

  const isExtWhatsappApiEnabled =
    configData?.featureToggle?.ext_whatsapp_api === true;

  const handleSaveExtWhatsappApi = () => {
    const baseUrl = extWhatsappBaseUrl?.trim();
    const apiKey = extWhatsappApiKey?.trim();

    if (!baseUrl) {
      toast.error(t("appConfig.enterExtWhatsappBaseUrl"));
      return;
    }
    if (!apiKey) {
      toast.error(t("appConfig.enterExtWhatsappApiKey"));
      return;
    }

    dispatch(
      updateConfigRequest({
        key: "extWhatsappApi",
        value: { baseUrl, apiKey },
      }),
    );
  };

  const handleSaveInfobipSms = () => {
    const baseUrl = infobipSmsBaseUrl?.trim();
    const apiKey = infobipSmsApiKey?.trim();
    const usSender = infobipSmsUsSender?.trim();

    if (!baseUrl) {
      toast.error(t("appConfig.enterInfobipSmsBaseUrl"));
      return;
    }
    if (!apiKey) {
      toast.error(t("appConfig.enterInfobipSmsApiKey"));
      return;
    }
    if (!usSender) {
      toast.error(t("appConfig.enterInfobipSmsUsSender"));
      return;
    }

    dispatch(
      updateConfigRequest({
        key: "infobipSms",
        value: {
          baseUrl,
          apiKey,
          senders: { US: usSender },
        },
      }),
    );
  };

  const handleConvenienceFeeSell = () => {
    dispatch(
      updateConfigRequest({
        key: "convenienceFeeSell",
        value: convenienceFeeSell,
      }),
    );
  };

  const handelDecimalPrecision = () => {
    if (!decimalPrecision) {
      toast.error("decimalPrecision cannot be empty");
      return;
    }
    dispatch(
      updateConfigRequest({ key: "decimalPrecision", value: decimalPrecision }),
    );
  };

  const handelMobileNumberLength = () => {
    if (!mobileNumberLength) {
      toast.error("mobileNumberLength cannot be empty");
      return;
    }
    dispatch(
      updateConfigRequest({
        key: "mobileNumberLength",
        value: mobileNumberLength,
      }),
    );
  };

  const handelBuyTextLabel = () => {
    dispatch(updateConfigRequest({ key: "buyTextLabel", value: buyTextLabel }));
  };

  const handelCdnUrl = () => {
    dispatch(updateConfigRequest({ key: "cdnUrl", value: cdnUrl }));
  };

  const handelLookBook = () => {
    dispatch(updateConfigRequest({ key: "lookbookText", value: lookbookText }));
  };

  const handelAppMode = () => {
    dispatch(updateConfigRequest({ key: "appMode", value: appMode }));
  };

  const handelCurrency = () => {
    dispatch(updateConfigRequest({ key: "currency", value: currency }));
  };

  const handleTermsAndConditionsUrl = () => {
    dispatch(
      updateConfigRequest({
        key: "termsAndConditionsUrl",
        value: termsAndConditionsUrl,
      }),
    );
  };

  const [androidConfig, setAndroidConfig] = useState({
    minVersion: "",
    maxVersion: "",
  });

  const [iosConfig, setIosConfig] = useState({
    minVersion: "",
    maxVersion: "",
  });
  // Android button handler
  const handleForceUpdateAndroid = (androidData) => {
    dispatch(
      updateConfigRequest({
        key: "forceUpdate",
        value: {
          android: {
            minVersion: Number(androidConfig.minVersion),
            maxVersion: Number(androidConfig.maxVersion),
          },
          ios: { ...iosConfig }, // ✅ keep existing iOS so it’s not wiped
        },
      }),
    );
  };

  // iOS button handler
  const handleForceUpdateIos = (iosData) => {
    dispatch(
      updateConfigRequest({
        key: "forceUpdate",
        value: {
          android: { ...androidConfig }, // ✅ keep existing Android so it’s not wiped
          ios: {
            minVersion: Number(iosConfig.minVersion),
            maxVersion: Number(iosConfig.maxVersion),
          },
        },
      }),
    );
  };
  const optionsUPIId = ["True"];
  const optionsFeature = [
    "Sell",
    "Gift",
    "Redeem",
    "Sip",
    "lookbook",
    "depositePlan",
  ];
  const optionsAmount = ["True", "False"];
  const optionsGateway = [
    "paytm",
    "cashfree",
    "razorpay",
    "payg",
    "ccavenue",
    "nomod",
  ];
  const optionsSIP = ["Online", "Offline"];
  const options = ["Online", "Offline"];

  useEffect(() => {
    dispatch(getAppConfig());
    dispatch(getBenefitsAndFeatures());
  }, []);

  useEffect(() => {
    dispatch(getActiveCountriesRequest({ jeweller: finalJewellerId }));
    dispatch(getSettingsRequest());
  }, [dispatch, finalJewellerId]);

  const normalizeGatewayName = (value) =>
    String(value || "")
      .toLowerCase()
      .replace(/\s/g, "");

  const enabledPaymentGateways = Array.isArray(paymentGateways)
    ? Array.from(new Set(paymentGateways.map(normalizeGatewayName).filter(Boolean)))
    : [];

  const normalizePaymentGatewayCountries = (raw) => {
    if (Array.isArray(raw)) return raw;
    if (Array.isArray(raw?.paymentGateways)) return raw.paymentGateways;
    if (Array.isArray(raw?.value?.paymentGateways)) {
      return raw.value.paymentGateways;
    }
    return [];
  };

  const getCountryId = (country) => {
    if (!country) return "";
    if (typeof country === "string") return country;
    return country._id || country.id || "";
  };

  useEffect(() => {
    setPaymentGatewayForCountries((prev) => {
      if (!enabledPaymentGateways.length) return "";
      return enabledPaymentGateways.includes(prev)
        ? prev
        : enabledPaymentGateways[0];
    });
  }, [paymentGateways]);

  useEffect(() => {
    const raw =
      settingsData?.data?.paymentGatewayCountries ??
      settingsData?.paymentGatewayCountries;
    setPaymentGatewayCountriesList(normalizePaymentGatewayCountries(raw));
  }, [settingsData]);

  useEffect(() => {
    const entry = paymentGatewayCountriesList.find(
      (item) =>
        normalizeGatewayName(item?.paymentGateway) ===
        normalizeGatewayName(paymentGatewayForCountries),
    );
    const ids = (entry?.countries || []).map(getCountryId).filter(Boolean);
    if (!activeCountries.length) {
      setPaymentGatewayCountryIds(ids);
      return;
    }
    const activeIds = new Set(activeCountries.map((country) => country._id));
    setPaymentGatewayCountryIds(ids.filter((id) => activeIds.has(id)));
  }, [
    paymentGatewayCountriesList,
    paymentGatewayForCountries,
    activeCountries,
  ]);

  const handleSavePaymentGatewayCountries = () => {
    if (!paymentGatewayForCountries) {
      toast.error("Please enable and select a payment gateway");
      return;
    }

    dispatch(
      savePaymentGatewayCountriesRequest({
        paymentGateway: paymentGatewayForCountries,
        countries: paymentGatewayCountryIds,
      }),
    );
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearMessage());
    } else if (message) {
      toast.success(message);
      dispatch(clearMessage());
    }
  }, [message, error, dispatch]);

  useEffect(() => {
    if (Object.keys(configData).length) {
      const incomingOfflineDetails = configData.offlinePaymentDetails || {};
      setOfflineDetails({
        bankName: "",
        accountNumber: "",
        ifscCode: "",
        sortCode: "",
        upiId: "",
        qrCodeUrl: "",
        ...incomingOfflineDetails,
        accountNumber:
          incomingOfflineDetails.accountNumber ||
          incomingOfflineDetails.accountNo ||
          "",
        sortCode: incomingOfflineDetails.sortCode || "",
        qrCodeUrl:
          incomingOfflineDetails.qrCodeUrl || incomingOfflineDetails.qr || "",
      });
      setQrCodeFile(null);
      setRemoveQr(false);
      setWhatsappNumber(configData.whatsappNumber || "");
      setExtWhatsappBaseUrl(configData.extWhatsappApi?.baseUrl || "");
      setExtWhatsappApiKey(configData.extWhatsappApi?.apiKey || "");
      setInfobipSmsBaseUrl(
        configData.infobipSms?.baseUrl || "https://55m1pg.api.infobip.com",
      );
      setInfobipSmsApiKey(configData.infobipSms?.apiKey || "");
      setInfobipSmsUsSender(configData.infobipSms?.senders?.US || "");
      setPaymentModeEnabled(configData.paymentModeEnabled || {});
      setSipPaymentModeEnabled(configData.sipPaymentModeEnabled || {});
      setPaymentGateways(configData.paymentGateways || []);
      setDecimalPrecision(configData.decimalPrecision || 0);
      setMobileNumberLength(configData.mobileNumberLength || 0);
      setConvenienceFeeSell(configData.convenienceFeeSell || 0);
      setBankList(configData.bankList || "");
      setTaxType(configData.taxtype || "");
      const incomingTaxApplicationMode = configData.taxApplicationMode;
      const normalizedTaxApplicationMode = VALID_TAX_APPLICATION_MODES.includes(
        incomingTaxApplicationMode,
      )
        ? incomingTaxApplicationMode
        : TAX_APPLICATION_MODES.STATE_WISE;
      setTaxApplicationMode(normalizedTaxApplicationMode);
      setTaxApplicationModeError("");
      setIsBuyGstEnabled(configData.isBuyGstEnabled !== false);
      setIsSipInstallmentGstEnabled(
        configData.isSipInstallmentGstEnabled !== false,
      );
      setIsGiftGstEnabled(configData.isGiftGstEnabled !== false);
      setBuyTextLabel(configData.buyTextLabel || "");
      setCdnUrl(configData.cdnUrl || "");
      setEnableSellViaUPI(configData.enableSellViaUPI === true);
      setLookbookText(configData.lookbookText || "");
      setFeatureToggle(configData.featureToggle || {});
      setBenefits(configData.benefits || []);
      setTermsAndConditionsUrl(configData.termsAndConditionsUrl || "");
      setShowCalculatedAmountInRedeem(
        configData.showCalculatedAmountInRedeem === true,
      );
      setAutoDebit(configData.autoDebit === true);
      setReferralRequiredRegistration(
        configData.referralRequiredRegistration === true,
      );
      setMiddleNameEnabled(configData.middleNameEnabled === true);
      setOfflinePaymentType(() => {
        const incoming = configData.offlinePaymentType;
        if (Array.isArray(incoming)) {
          const selected = incoming.map((item) => String(item).toLowerCase());
          return {
            store: selected.includes("store"),
            home: selected.includes("home"),
          };
        }
        if (incoming && typeof incoming === "object") {
          return {
            store: incoming.store === true,
            home: incoming.home === true,
          };
        }
        return { store: true, home: true };
      });
      const incomingAppStatus = configData.jewellerAppStatus;
      setJewellerAppStatus((current) => ({
        ios: Object.prototype.hasOwnProperty.call(incomingAppStatus || {}, "ios")
          ? incomingAppStatus.ios === true
          : current.ios,
        android: Object.prototype.hasOwnProperty.call(
          incomingAppStatus || {},
          "android",
        )
          ? incomingAppStatus.android === true
          : current.android,
      }));
      setAppMode(configData.appMode || "PROD");
      setCurrency(configData.currency || "INR");

      if (configData.forceUpdate) {
        setAndroidConfig(
          configData.forceUpdate.android || { minVersion: "", maxVersion: "" },
        );
        setIosConfig(
          configData.forceUpdate.ios || { minVersion: "", maxVersion: "" },
        );
      }
      setAppLinks({
        androidAppLink: configData.appLinks?.androidAppLink || "",
        iosAppLink: configData.appLinks?.iosAppLink || "",
        oneLink: configData.appLinks?.oneLink || "",
      });
    }
  }, [configData]);

  const handleSaveAppLinks = () => {
    dispatch(
      updateConfigRequest({
        key: "appLinks",
        value: appLinks,
      }),
    );
  };

  const [permissions, setPermissions] = useState({});
  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (error) {
        console.error("Error parsing stored permissions", error);
      }
    }
  }, []);
  const canCreateSetting = canShowPermission(
    permissions,
    "appConfig",
    "create",
  );
  const canEdit = canShowPermission(permissions, "appConfig", "edit");
  const canDelete = canShowPermission(permissions, "appConfig", "delete");
  const [mainTab, setMainTab] = useState(0);
  const [subTab, setSubTab] = useState(0);
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          width: "100%",
          mt: 0,
          background: "#fff",
          borderRadius: "16px",

          mb: 3,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Typography
          fontFamily={"Aeonik"}
          sx={{ fontSize: "24px", fontWeight: 700, p: 2 }}
        >
          {t("appConfig.appConfiguration")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={mainTab}
            onChange={(e, val) => {
              setMainTab(val);
              setSubTab(0); // reset subtabs
            }}
            sx={{
              borderRight: 1,
              borderColor: "divider",
              minWidth: 180,
              width: "20%",
              maxHeight: "80vh",
              overflowY: "auto",

              "& .MuiTab-root": {
                justifyContent: "flex-start",
                alignItems: "flex-start",
                textAlign: "left",
                textTransform: "none",
                fontSize: "14px",
                fontWeight: 600,
                fontStyle: "inherit",
                fontFamily: "initial", // ✅ apply font family to all tabs
              },
              "& .Mui-selected": {
                color: "primary.main",
                backgroundColor: "rgba(25, 118, 210, 0.08)",
                borderLeft: "3px solid",
                borderColor: "primary.main",
              },

              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#bbb",
                borderRadius: "10px",
              },
            }}
          >
            <Tab label={t("appConfig.payment")} />
            <Tab label={t("appConfig.paymentGatewayCountries")} />
            <Tab label={t("appConfig.mobile")} />
            <Tab label={t("appConfig.bankDetails")} />
            <Tab label={t("appConfig.buyText")} />
            <Tab label={t("appConfig.enableSellViaUpiId")} />
            <Tab label={t("appConfig.decimal")} />
            <Tab label={t("appConfig.currency")} />
            <Tab label={t("appConfig.convenienceCharge")} />
            <Tab label={t("appConfig.cdnUrl")} />
            <Tab label={t("appConfig.taxType")} />
            <Tab label={t("appConfig.lookBook")} />
            <Tab label={t("appConfig.mode")} />
            <Tab label={t("appConfig.termsAndCondition")} />
            <Tab label={t("appConfig.showCalculationAmountInRedeem")} />
            <Tab label={t("appConfig.referralRequiredWhileRegistration")} />
            <Tab label={t("appConfig.appLinks")} />
            <Tab label={t("appConfig.customermiddlename")} />
            <Tab label={t("appConfig.offlinePaymentType")} />
            <Tab label="Jeweller App Status" />
          </Tabs>
          {/* Offineline Payment and Address section */}
          <Box sx={{ width: "80%", ml: "10px" }}>
            {mainTab === 1 && (
              <Paper
                elevation={2}
                sx={{
                  p: 3,
                  width: "100%",
                  border: "1px solid #ccc",
                }}
              >
                <Typography
                  fontWeight={700}
                  fontSize={24}
                  mb={3}
                  fontFamily={"Aeonik"}
                >
                  {t("appConfig.paymentGatewayCountries")}
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item size={6}>
                    <TextField
                      select
                      size="small"
                      fullWidth
                      label={t("appConfig.paymentGateway")}
                      value={paymentGatewayForCountries}
                      disabled={!enabledPaymentGateways.length}
                      onChange={(e) =>
                        setPaymentGatewayForCountries(e.target.value)
                      }
                    >
                      {enabledPaymentGateways.length === 0 && (
                        <MenuItem value="">
                          Enable a payment gateway first
                        </MenuItem>
                      )}
                      {enabledPaymentGateways.map((gateway) => (
                        <MenuItem key={gateway} value={gateway}>
                          {gateway}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item size={6}>
                    <FormControl
                      fullWidth
                      size="small"
                      disabled={!paymentGatewayForCountries}
                    >
                      <InputLabel id="payment-gateway-countries-label">
                        Select Countries
                      </InputLabel>
                      <Select
                        labelId="payment-gateway-countries-label"
                        multiple
                        value={paymentGatewayCountryIds}
                        onChange={(e) =>
                          setPaymentGatewayCountryIds(e.target.value)
                        }
                        input={<OutlinedInput label="Select Countries" />}
                        renderValue={(selected) => (
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 0.5,
                            }}
                          >
                            {selected.map((id) => {
                              const country = activeCountries.find(
                                (item) => item._id === id,
                              );
                              return (
                                <Chip
                                  key={id}
                                  size="small"
                                  label={country?.countryName || id}
                                />
                              );
                            })}
                          </Box>
                        )}
                      >
                        {activeCountries.map((country) => (
                          <MenuItem key={country._id} value={country._id}>
                            {country.countryName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {(canCreateSetting || canEdit) && (
                    <Grid item size={12}>
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "#752ADA",
                          px: 6,
                          textTransform: "none",
                          mt: 1,
                        }}
                        onClick={handleSavePaymentGatewayCountries}
                      >
                        Save
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </Paper>
            )}
            {mainTab === 0 && (
              <Box
                sx={{
                  width: "100%",
                  justifyContent: "space-between",
                  mb: 2,
                }}
              >
                <Tabs
                  value={subTab}
                  onChange={(e, val) => setSubTab(val)}
                  sx={{ borderBottom: 1, borderColor: "divider" }}
                >
                  <Tab label={t("appConfig.offlinePayment")} />
                  <Tab label={t("appConfig.sipPayments")} />
                  <Tab label={t("appConfig.paymentMode")} />
                  <Tab label={t("appConfig.paymentGateway")} />
                </Tabs>
                {/* Offline Payment Section */}
                {subTab === 0 && (
                  <Paper
                    elevation={2}
                    sx={{
                      p: 3,
                      mt: 3,
                      width: "100%",
                      border: "1px solid #ccc",
                    }}
                  >
                    <Typography
                      fontWeight={700}
                      fontSize={24}
                      mb={3}
                      fontFamily={"Aeonik"}
                    >
                      Offline Payment
                    </Typography>

                    {/* Row 1 :- account number and sort code */}
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      <Grid item size={6}>
                        <TextField
                          fullWidth
                          label={t("appConfig.accountNumber")}
                          placeholder={t("appConfig.enterAccountNumber")}
                          size="small"
                          value={offlineDetails.accountNumber}
                          onChange={(e) => {
                            const input = e.target.value;
                            if (/^\d*$/.test(input)) {
                              setOfflineDetails({
                                ...offlineDetails,
                                accountNumber: input,
                              });
                            }
                          }}
                          inputProps={{
                            inputMode: "numeric",
                          }}
                        />
                      </Grid>
                      <Grid item size={6}>
                        <TextField
                          fullWidth
                          label={t("appConfig.sortCode")}
                          placeholder={t("appConfig.enterSortCode")}
                          size="small"
                          value={offlineDetails.sortCode || ""}
                          onChange={(e) =>
                            setOfflineDetails({
                              ...offlineDetails,
                              sortCode: e.target.value,
                            })
                          }
                        />
                      </Grid>
                    </Grid>

                    {/* Row 2 :- IFSC code and UPI id */}
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      <Grid item size={6}>
                        <TextField
                          fullWidth
                          label={t("appConfig.ifscCode")}
                          placeholder={t("appConfig.enterIfscCode")}
                          size="small"
                          value={offlineDetails.ifscCode}
                          onChange={(e) =>
                            setOfflineDetails({
                              ...offlineDetails,
                              ifscCode: e.target.value,
                            })
                          }
                        />
                      </Grid>
                      <Grid item size={6}>
                        <TextField
                          fullWidth
                          label={t("appConfig.upiId")}
                          placeholder={t("appConfig.enterUpiId")}
                          size="small"
                          value={offlineDetails.upiId}
                          onChange={(e) =>
                            setOfflineDetails({
                              ...offlineDetails,
                              upiId: e.target.value,
                            })
                          }
                        />
                      </Grid>
                    </Grid>

                    {/* Row 3 :- choose file container*/}
                    <Grid container spacing={2} sx={{ mt: 2 }}>

                      {/* Choose File */}
                      <Grid item size={6}>
                        <Box display="flex" alignItems="center" gap={2}>
                          <input
                            type="file"
                            accept="image/*"
                            id="file-upload"
                            onClick={(e) => {
                              e.target.value = null;
                            }}
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (file) {
                                if (!file.type.startsWith("image/")) {
                                  toast.error(
                                    "Please select a valid image file",
                                  );
                                  return;
                                }
                                const qrCodeUrl = URL.createObjectURL(file);
                                setOfflineDetails((prev) => ({
                                  ...prev,
                                  qrCodeUrl,
                                }));
                                setQrCodeFile(file);
                                setRemoveQr(false);
                              }
                            }}
                            style={{ display: "none" }}
                          />
                          <label htmlFor="file-upload">
                            <Button
                              variant="outlined"
                              component="span"
                              sx={{ textTransform: "none" }}
                            >
                              Choose QR Image
                            </Button>
                          </label>
                        </Box>
                        {/* Show QR preview if available */}
                        {offlineDetails.qrCodeUrl && (
                          <Box mt={2} display="flex" alignItems="flex-start" gap={2}>
                            <img
                              src={offlineDetails.qrCodeUrl}
                              alt="QR Code"
                              style={{ width: 100, height: "auto" }}
                            />
                            <Button
                              variant="outlined"
                              color="error"
                              size="small"
                              sx={{ textTransform: "none" }}
                              onClick={() => {
                                if (
                                  typeof offlineDetails.qrCodeUrl === "string" &&
                                  offlineDetails.qrCodeUrl.startsWith("blob:")
                                ) {
                                  URL.revokeObjectURL(offlineDetails.qrCodeUrl);
                                }
                                setOfflineDetails((prev) => ({
                                  ...prev,
                                  qrCodeUrl: "",
                                }));
                                setQrCodeFile(null);
                                setRemoveQr(true);
                              }}
                            >
                              Remove QR Image
                            </Button>
                          </Box>
                        )}
                      </Grid>

                      {(canCreateSetting || canEdit) && (
                        <Grid item xs={12}>
                          <Button
                            variant="contained"
                            sx={{ bgcolor: "#752ADA", textTransform: "none" }}
                            onClick={handleOfflinePaymentSave}
                          >
                            Save
                          </Button>
                        </Grid>
                      )}
                    </Grid>

                    {/* <Button
                variant="contained"
                sx={{ bgcolor: "#752ADA", px: 6, textTransform: "none", mt: 3 }}
              >
                Save
              </Button> */}
                  </Paper>
                )}

                {subTab === 1 && (
                  <Reusable
                    label="SIP Payments"
                    options={optionsSIP}
                    selected={sipPaymentModeEnabled}
                    onChange={setSipPaymentModeEnabled}
                    onSave={() =>
                      dispatch(
                        updateConfigRequest({
                          key: "sipPaymentModeEnabled",
                          value: sipPaymentModeEnabled,
                        }),
                      )
                    }
                    showButton={canCreateSetting || canEdit}
                  />
                )}

                {subTab === 2 && (
                  <>
                    {/* Payment mode */}
                    <Reusable
                      label="Payment Mode"
                      options={options}
                      selected={paymentModeEnabled}
                      onChange={setPaymentModeEnabled}
                      onSave={() =>
                        dispatch(
                          updateConfigRequest({
                            key: "paymentModeEnabled",
                            value: paymentModeEnabled,
                          }),
                        )
                      }
                      showButton={canCreateSetting || canEdit}
                    />
                  </>
                )}

                {subTab === 3 && (
                  <>
                    {/* Payment gateway  */}
                    <Reusable
                      label="Payment Gateway"
                      options={optionsGateway}
                      selected={paymentGateways}
                      onChange={setPaymentGateways}
                      onSave={() => {
                        const normalize = (v) =>
                          v.toLowerCase().replace(/\s/g, "");
                        const validOptions = optionsGateway.map(normalize);

                        const cleaned = paymentGateways
                          .map(normalize)
                          .filter((v) => validOptions.includes(v));

                        dispatch(
                          updateConfigRequest({
                            key: "paymentGateways",
                            value: cleaned,
                          }),
                        );
                      }}
                      showButton={canCreateSetting || canEdit}
                      // multi={true}
                    />
                  </>
                )}
              </Box>
            )}
            {mainTab === 2 && (
              <>
                <Tabs
                  value={subTab}
                  onChange={(e, val) => setSubTab(val)}
                  sx={{ borderBottom: 1, borderColor: "divider" }}
                >
                  <Tab label=" WhatsApp Integration" />
                  <Tab label={t("appConfig.extWhatsappApi")} />
                  <Tab label={t("appConfig.mobileNumberLength")} />
                  <Tab label={t("appConfig.forceUpdate")} />
                  <Tab label={t("appConfig.infobipSms")} />
                </Tabs>
                {subTab === 0 && (
                  <Paper
                    elevation={2}
                    sx={{
                      p: 3,
                      mt: 3,
                      width: "100%",
                      border: "1px solid #ccc",
                    }}
                  >
                    <Typography
                      fontWeight={700}
                      fontSize={24}
                      mb={3}
                      fontFamily={"Aeonik"}
                    >
                      WhatsApp Integration
                    </Typography>
                    {/* Whatsapp Number Texfield and Button */}
                    <Grid container spacing={2}>
                      <TextField
                        size="small"
                        fullWidth
                        label={t("appConfig.whatsappNumber")}
                        placeholder={t("appConfig.enterWhatsappNumber")}
                        value={whatsappNumber}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[6-9][0-9]{0,9}$/.test(value) || value === "") {
                            setWhatsappNumber(value);
                          }
                        }}
                        inputProps={{
                          maxLength: 10,
                          inputMode: "numeric",
                          pattern: "[6-9]{1}[0-9]{9}",
                        }}
                      />
                    </Grid>
                    {/* add button */}
                    {(canCreateSetting || canEdit) && (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "#752ADA",
                          px: 6,
                          textTransform: "none",
                          mt: 3,
                        }}
                        onClick={handleSaveWhatsAppNo}
                      >
                        Add
                      </Button>
                    )}
                  </Paper>
                )}
                {subTab === 1 && (
                  <Paper
                    elevation={2}
                    sx={{
                      p: 3,
                      mt: 3,
                      width: "100%",
                      border: "1px solid #ccc",
                    }}
                  >
                    <Typography
                      fontWeight={700}
                      fontSize={24}
                      mb={2}
                      fontFamily={"Aeonik"}
                    >
                      {t("appConfig.extWhatsappApi")}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      mb={2}
                      fontFamily="Inter"
                    >
                      {t("appConfig.extWhatsappApiDescription")}
                    </Typography>
                    {!isExtWhatsappApiEnabled && (
                      <Alert severity="info" sx={{ mb: 2 }}>
                        {t("appConfig.extWhatsappFeatureDisabled")}
                      </Alert>
                    )}
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          size="small"
                          fullWidth
                          label={t("appConfig.extWhatsappBaseUrl")}
                          placeholder={t("appConfig.enterExtWhatsappBaseUrl")}
                          value={extWhatsappBaseUrl}
                          onChange={(e) =>
                            setExtWhatsappBaseUrl(e.target.value)
                          }
                          disabled={!isExtWhatsappApiEnabled}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          size="small"
                          fullWidth
                          type="password"
                          label={t("appConfig.extWhatsappApiKey")}
                          placeholder={t("appConfig.enterExtWhatsappApiKey")}
                          value={extWhatsappApiKey}
                          onChange={(e) => setExtWhatsappApiKey(e.target.value)}
                          disabled={!isExtWhatsappApiEnabled}
                          autoComplete="new-password"
                        />
                      </Grid>
                    </Grid>
                    {(canCreateSetting || canEdit) && (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "#752ADA",
                          px: 6,
                          textTransform: "none",
                          mt: 3,
                        }}
                        onClick={handleSaveExtWhatsappApi}
                        disabled={!isExtWhatsappApiEnabled}
                      >
                        {t("appConfig.saveExtWhatsappApi")}
                      </Button>
                    )}
                  </Paper>
                )}
                {subTab === 2 && (
                  <Paper
                    elevation={2}
                    sx={{
                      p: 3,
                      mt: 2,
                      width: "100%",
                      border: "1px solid #ccc",
                    }}
                  >
                    <Typography
                      fontWeight={700}
                      fontSize={24}
                      mb={3}
                      fontFamily={"Aeonik"}
                    >
                      Mobile Number Length
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item size={12}>
                        <TextField
                          size="small"
                          fullWidth
                          label={t("appConfig.mobileNumberLength")}
                          placeholder={t("appConfig.enterMobileNumberLength")}
                          value={mobileNumberLength}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                              setMobileNumberLength(value);
                            }
                          }}
                          inputProps={{
                            inputMode: "numeric",
                            maxLength: 2,
                          }}
                        />
                      </Grid>
                    </Grid>
                    {(canCreateSetting || canEdit) && (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "#752ADA",
                          px: 6,
                          textTransform: "none",
                          mt: 3,
                        }}
                        onChange={setMobileNumberLength}
                        onClick={handelMobileNumberLength}
                      >
                        Save
                      </Button>
                    )}
                  </Paper>
                )}
                {subTab === 3 && (
                  <Paper
                    elevation={2}
                    sx={{
                      p: 3,
                      mt: 3,
                      width: "100%",
                      border: "1px solid #ccc",
                    }}
                  >
                    <Typography
                      fontWeight={700}
                      fontSize={24}
                      mb={2}
                      fontFamily={"Aeonik"}
                    >
                      Force Update{" "}
                    </Typography>
                    <Typography
                      fontWeight={700}
                      fontSize={20}
                      mb={1}
                      fontFamily={"Aeonik"}
                      color="gray"
                    >
                      Android{" "}
                    </Typography>
                    {/* Row 1 :- account number and IFSC code  container */}
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      {/* ANDROID */}
                      <Grid item xs={4}>
                        <TextField
                          fullWidth
                          label={t("appConfig.minVersion")}
                          placeholder={t("appConfig.enterMinVersion")}
                          size="small"
                          value={androidConfig.minVersion}
                          // ANDROID minVersion
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              !androidConfig.maxVersion ||
                              Number(value) <= Number(androidConfig.maxVersion)
                            ) {
                              setAndroidConfig({
                                ...androidConfig,
                                minVersion: value,
                              });
                            } else {
                              alert(
                                "Min version cannot be greater than Max version",
                              );
                            }
                          }}
                          inputProps={{ inputMode: "numeric" }}
                        />
                      </Grid>

                      <Grid item xs={4}>
                        <TextField
                          fullWidth
                          label={t("appConfig.maxVersion")}
                          placeholder={t("appConfig.enterMaxVersion")}
                          size="small"
                          value={androidConfig.maxVersion}
                          // ANDROID maxVersion
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              !androidConfig.minVersion ||
                              Number(value) >= Number(androidConfig.minVersion)
                            ) {
                              setAndroidConfig({
                                ...androidConfig,
                                maxVersion: value,
                              });
                            } else {
                              alert(
                                "Max version cannot be less than Min version",
                              );
                            }
                          }}
                          inputProps={{ inputMode: "numeric" }}
                        />
                      </Grid>

                      {/* Row 2 :- UPI id and choose file container*/}
                      {/* Choose File */}

                      <Button
                        variant="contained"
                        sx={{ bgcolor: "#752ADA", textTransform: "none" }}
                        onClick={handleForceUpdateAndroid} // ✅ no event passed
                      >
                        Add
                      </Button>
                    </Grid>

                    <Typography
                      fontWeight={700}
                      fontSize={20}
                      mb={1}
                      mt={2}
                      fontFamily={"Aeonik"}
                      color="gray"
                    >
                      Ios{" "}
                    </Typography>
                    {/* Row 1 :- account number and IFSC code  container */}
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      {/* IOS Min Version */}
                      <Grid item xs={4}>
                        <TextField
                          fullWidth
                          label={t("appConfig.minVersion")}
                          placeholder={t("appConfig.enterMinVersion")}
                          size="small"
                          value={iosConfig.minVersion}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              !iosConfig.maxVersion ||
                              Number(value) <= Number(iosConfig.maxVersion)
                            ) {
                              setIosConfig({ ...iosConfig, minVersion: value });
                            } else {
                              alert(
                                "Min version cannot be greater than Max version",
                              );
                            }
                          }}
                          inputProps={{ inputMode: "numeric" }}
                        />
                      </Grid>

                      {/* IOS Max Version */}
                      <Grid item xs={4}>
                        <TextField
                          fullWidth
                          label={t("appConfig.maxVersion")}
                          placeholder={t("appConfig.enterMaxVersion")}
                          size="small"
                          value={iosConfig.maxVersion}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              !iosConfig.minVersion ||
                              Number(value) >= Number(iosConfig.minVersion)
                            ) {
                              setIosConfig({ ...iosConfig, maxVersion: value });
                            } else {
                              alert(
                                "Max version cannot be less than Min version",
                              );
                            }
                          }}
                          inputProps={{ inputMode: "numeric" }}
                        />
                      </Grid>

                      {/* Row 2 :- UPI id and choose file container*/}
                      {/* Choose File */}
                      <Button
                        variant="contained"
                        sx={{ bgcolor: "#752ADA", textTransform: "none" }}
                        // onClick={handleForceUpdateIos}
                        onClick={handleForceUpdateIos} // ✅ no event passed
                      >
                        Add
                      </Button>
                    </Grid>

                    {/* <Button
                variant="contained"
                sx={{ bgcolor: "#752ADA", px: 6, textTransform: "none", mt: 3 }}
              >
                Save
              </Button> */}
                  </Paper>
                )}
                {subTab === 4 && (
                  <Paper
                    elevation={2}
                    sx={{
                      p: 3,
                      mt: 3,
                      width: "100%",
                      border: "1px solid #ccc",
                    }}
                  >
                    <Typography
                      fontWeight={700}
                      fontSize={24}
                      mb={2}
                      fontFamily={"Aeonik"}
                    >
                      {t("appConfig.infobipSms")}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      mb={2}
                      fontFamily="Inter"
                    >
                      {t("appConfig.infobipSmsDescription")}
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          size="small"
                          fullWidth
                          label={t("appConfig.infobipSmsBaseUrl")}
                          placeholder={t("appConfig.enterInfobipSmsBaseUrl")}
                          value={infobipSmsBaseUrl}
                          onChange={(e) => setInfobipSmsBaseUrl(e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          size="small"
                          fullWidth
                          type="password"
                          label={t("appConfig.infobipSmsApiKey")}
                          placeholder={t("appConfig.enterInfobipSmsApiKey")}
                          value={infobipSmsApiKey}
                          onChange={(e) => setInfobipSmsApiKey(e.target.value)}
                          autoComplete="new-password"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          size="small"
                          fullWidth
                          label={t("appConfig.infobipSmsUsSender")}
                          placeholder={t("appConfig.enterInfobipSmsUsSender")}
                          value={infobipSmsUsSender}
                          onChange={(e) =>
                            setInfobipSmsUsSender(e.target.value)
                          }
                        />
                      </Grid>
                    </Grid>
                    {(canCreateSetting || canEdit) && (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "#752ADA",
                          px: 6,
                          textTransform: "none",
                          mt: 3,
                        }}
                        onClick={handleSaveInfobipSms}
                      >
                        {t("appConfig.saveInfobipSms")}
                      </Button>
                    )}
                  </Paper>
                )}
              </>
            )}

            {mainTab === 3 && (
              <>
                <Paper
                  elevation={2}
                  sx={{ p: 3, width: "100%", border: "1px solid #ccc" }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    Bank List
                  </Typography>

                  <Grid item xs={12}>
                    <TextField
                      size="small"
                      fullWidth
                      label={t("appConfig.bankName")}
                      placeholder={t("appConfig.enterBankNameHere")}
                      value={bankName}
                      onChange={(e) => setBankName(e.target.value)}
                    />
                  </Grid>

                  <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                    {(canCreateSetting || canEdit) && (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "#752ADA",
                          px: 6,
                          textTransform: "none",
                        }}
                        onClick={() => {
                          const trimmed = bankName.trim();
                          if (!trimmed) {
                            toast.error("Bank name is required");
                            return;
                          }
                          if (bankList.includes(trimmed)) {
                            toast.error("Bank already exists");
                            return;
                          }
                          setBankList([...bankList, trimmed]);
                          setBankName("");
                        }}
                      >
                        Add
                      </Button>
                    )}
                    {(canCreateSetting || canEdit) && bankList.length > 0 && (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "#752ADA",
                          px: 6,
                          textTransform: "none",
                        }}
                        onClick={() =>
                          dispatch(
                            updateConfigRequest({
                              key: "bankList",
                              value: bankList,
                            }),
                          )
                        }
                      >
                        Save
                      </Button>
                    )}
                  </Box>
                  {bankList.length > 0 && (
                    <Box
                      sx={{ mt: 3, display: "flex", gap: 1, flexWrap: "wrap" }}
                    >
                      {bankList.map((bank, idx) => (
                        <Box
                          key={idx}
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Chip label={bank} color="primary" />
                          <IconButton
                            size="small"
                            color="secondary"
                            onClick={() => {
                              setBankName(bank);
                              setBankList(bankList.filter((_, i) => i !== idx));
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => {
                              setBankList(bankList.filter((_, i) => i !== idx));
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Paper>
              </>
            )}

            {mainTab === 4 && (
              <>
                <Tabs
                  value={subTab}
                  onChange={(e, val) => setSubTab(val)}
                  sx={{ borderBottom: 1, borderColor: "divider" }}
                >
                  <Tab label={t("appConfig.buyText")} />
                  {/* <Tab label="Currency" /> */}
                </Tabs>
                {subTab === 0 && (
                  <Paper
                    elevation={2}
                    sx={{
                      p: 3,
                      mt: 3,
                      width: "100%",
                      border: "1px solid #ccc",
                    }}
                  >
                    <Typography
                      fontWeight={700}
                      fontSize={24}
                      mb={3}
                      fontFamily={"Aeonik"}
                    >
                      Buy Text
                    </Typography>
                    {/* Buy Text  Texfield and Button */}
                    <Grid container spacing={2}>
                      <TextField
                        size="small"
                        fullWidth
                        label={t("appConfig.buyText")}
                        placeholder={t("appConfig.enterBuyTextHere")}
                        value={buyTextLabel}
                        onChange={(e) => setBuyTextLabel(e.target.value)}
                      />
                    </Grid>
                    {/* add button */}
                    {(canCreateSetting || canEdit) && (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "#752ADA",
                          px: 6,
                          textTransform: "none",
                          mt: 3,
                        }}
                        onClick={handelBuyTextLabel}
                      >
                        Add
                      </Button>
                    )}
                  </Paper>
                )}
              </>
            )}

            {mainTab === 5 && (
              <>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    mt: 3,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    Enable Sell Via UPI Id
                  </Typography>

                  <FormGroup row sx={{ color: "#7B8499" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enableSellViaUPI}
                          onChange={(e) =>
                            setEnableSellViaUPI(e.target.checked)
                          }
                          sx={{
                            color: "#7b8499",
                            "&.Mui-checked": {
                              color: "#4caf50",
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          variant="body2"
                          fontFamily={"Inter"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          color="#7b8499"
                        >
                          Enable
                        </Typography>
                      }
                    />
                  </FormGroup>

                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onClick={handleSaveEnableSellViaUPI}
                    >
                      Save
                    </Button>
                  )}
                </Paper>
              </>
            )}
            {mainTab === 6 && (
              <>
                <Paper
                  elevation={2}
                  sx={{ p: 3, width: "100%", border: "1px solid #ccc" }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    Decimal
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item size={12}>
                      <TextField
                        size="small"
                        fullWidth
                        label={t("appConfig.decimal")}
                        placeholder="decimal"
                        value={decimalPrecision}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Allow only digits
                          if (/^\d*$/.test(value)) {
                            setDecimalPrecision(value);
                          }
                        }}
                        inputProps={{
                          inputMode: "numeric",
                          maxLength: 2,
                        }}
                      />
                    </Grid>
                  </Grid>
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onChange={setDecimalPrecision}
                      onClick={handelDecimalPrecision}
                    >
                      Save
                    </Button>
                  )}
                </Paper>
              </>
            )}

            {mainTab === 7 && (
              <Paper
                elevation={2}
                sx={{ p: 3, mt: 3, width: "100%", border: "1px solid #ccc" }}
              >
                <Typography
                  fontWeight={700}
                  fontSize={24}
                  mb={3}
                  fontFamily={"Aeonik"}
                >
                  Currency
                </Typography>

                <Grid item xs={20}>
                  <FormControl size="small" sx={{ width: "100%" }}>
                    <InputLabel>{t("appConfig.selectCurrency")}</InputLabel>
                    <Select
                      label={t("appConfig.selectOption")}
                      value={currency}
                      onChange={(e) => setCurrency(e.target.value)}
                    >
                      <MenuItem value="">
                        {t("appConfig.selectCurrency")}
                      </MenuItem>
                      {Object.values(CurrencyList).map((code) => (
                        <MenuItem key={code} value={code}>
                          {code}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {(canCreateSetting || canEdit) && (
                  <Button
                    variant="contained"
                    sx={{
                      bgcolor: "#752ADA",
                      px: 6,
                      textTransform: "none",
                      mt: 3,
                    }}
                    onClick={handelCurrency}
                  >
                    Add
                  </Button>
                )}
              </Paper>
            )}

            {/*  Convenience Charge section */}
            {mainTab === 8 && (
              <>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    Convenience Charge
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item size={6}>
                      {/*  Convenience Charge textfield */}
                      <TextField
                        label={
                          <>
                            Convenience Charge %{" "}
                            <span style={{ color: "red" }}>*</span>
                          </>
                        }
                        placeholder="0"
                        fullWidth
                        value={convenienceFeeSell}
                        onChange={(e) => setConvenienceFeeSell(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                  {/* save button */}
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onClick={handleConvenienceFeeSell}
                    >
                      Save
                    </Button>
                  )}
                </Paper>
              </>
            )}

            {/* CDN URL  */}
            {mainTab === 9 && (
              <>
                <Paper
                  elevation={2}
                  sx={{ p: 3, width: "100%", border: "1px solid #ccc" }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    CDN URL
                  </Typography>
                  {/*CDN URL  Texfield and Button */}
                  <Grid container spacing={2}>
                    <TextField
                      size="small"
                      fullWidth
                      label={t("appConfig.cdnUrl")}
                      placeholder={t("appConfig.enterCdnUrlHere")}
                      value={cdnUrl}
                      onChange={(e) => setCdnUrl(e.target.value)}
                    />
                  </Grid>
                  {/* add button */}
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onClick={handelCdnUrl}
                    >
                      Add
                    </Button>
                  )}
                </Paper>
              </>
            )}

            {/* Tax Type  */}
            {mainTab === 10 && (
              <>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    Tax Type
                  </Typography>

                  <FormGroup row sx={{ color: "#7B8499", gap: 7 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={taxType === "GST"}
                          onChange={() => setTaxType("GST")}
                          sx={{
                            color: "#7b8499",
                            "&.Mui-checked": { color: "#4caf50" },
                          }}
                        />
                      }
                      label={
                        <Typography
                          fontSize="14px"
                          fontWeight="500"
                          color="#7b8499"
                        >
                          GST
                        </Typography>
                      }
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={taxType === "VAT"}
                          onChange={() => setTaxType("VAT")}
                          sx={{
                            color: "#7b8499",
                            "&.Mui-checked": { color: "#4caf50" },
                          }}
                        />
                      }
                      label={
                        <Typography
                          fontSize="14px"
                          fontWeight="500"
                          color="#7b8499"
                        >
                          VAT
                        </Typography>
                      }
                    />
                  </FormGroup>

                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onClick={handleSaveTaxType}
                    >
                      Save
                    </Button>
                  )}
                  <Box sx={{ mt: 4 }}>
                    <Typography
                      fontWeight={700}
                      fontSize={20}
                      mb={1}
                      fontFamily={"Aeonik"}
                      color="gray"
                    >
                      Tax Application Mode
                    </Typography>
                    <Grid item xs={12}>
                      <FormControl
                        fullWidth
                        size="small"
                        error={Boolean(taxApplicationModeError)}
                      >
                        <InputLabel>Tax Application Mode</InputLabel>
                        <Select
                          label="Tax Application Mode"
                          value={taxApplicationMode}
                          onChange={(e) => {
                            const selectedMode = e.target.value;
                            setTaxApplicationMode(selectedMode);
                            if (
                              VALID_TAX_APPLICATION_MODES.includes(selectedMode)
                            ) {
                              setTaxApplicationModeError("");
                            }
                          }}
                        >
                          <MenuItem value={TAX_APPLICATION_MODES.SGST_CGST}>
                            Apply only SGST + CGST
                          </MenuItem>
                          <MenuItem value={TAX_APPLICATION_MODES.IGST}>
                            Apply only IGST
                          </MenuItem>
                          <MenuItem value={TAX_APPLICATION_MODES.STATE_WISE}>
                            Apply tax based on customer and jeweller state
                          </MenuItem>
                        </Select>
                        {taxApplicationModeError ? (
                          <FormHelperText>
                            {taxApplicationModeError}
                          </FormHelperText>
                        ) : null}
                      </FormControl>
                    </Grid>
                    <Box sx={{ mt: 1.5 }}>
                      {TAX_APPLICATION_MODE_DESCRIPTIONS.map((description) => (
                        <Typography
                          key={description}
                          variant="body2"
                          color="text.secondary"
                          sx={{ lineHeight: 1.6 }}
                        >
                          {description}
                        </Typography>
                      ))}
                    </Box>
                    {(canCreateSetting || canEdit) && (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "#752ADA",
                          px: 6,
                          textTransform: "none",
                          mt: 3,
                        }}
                        onClick={handleSaveTaxApplicationMode}
                      >
                        Save
                      </Button>
                    )}
                  </Box>

                  <Box sx={{ mt: 4 }}>
                    <Typography
                      fontWeight={700}
                      fontSize={20}
                      mb={2}
                      fontFamily={"Aeonik"}
                      color="gray"
                    >
                      Module-wise GST
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 2, lineHeight: 1.6 }}
                    >
                      Enable or disable GST independently for each module.
                      Disabling GST for one module does not affect the others.
                    </Typography>
                    <FormGroup sx={{ color: "#7B8499", gap: 1 }}>
                      {[
                        {
                          key: "isBuyGstEnabled",
                          label: "Enable GST for Buy",
                          checked: isBuyGstEnabled,
                          setter: setIsBuyGstEnabled,
                        },
                        {
                          key: "isSipInstallmentGstEnabled",
                          label: "Enable GST for Installment",
                          checked: isSipInstallmentGstEnabled,
                          setter: setIsSipInstallmentGstEnabled,
                        },
                        {
                          key: "isGiftGstEnabled",
                          label: "Enable GST for Gift",
                          checked: isGiftGstEnabled,
                          setter: setIsGiftGstEnabled,
                        },
                      ].map((item) => (
                        <Box
                          key={item.key}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            gap: 1,
                            py: 0.5,
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={item.checked}
                                onChange={(e) =>
                                  item.setter(e.target.checked)
                                }
                                sx={{
                                  color: "#7b8499",
                                  "&.Mui-checked": { color: "#4caf50" },
                                }}
                              />
                            }
                            label={
                              <Typography
                                fontSize="14px"
                                fontWeight="500"
                                color="#7b8499"
                              >
                                {item.label}
                              </Typography>
                            }
                          />
                          {(canCreateSetting || canEdit) && (
                            <Button
                              variant="contained"
                              size="small"
                              sx={{
                                bgcolor: "#752ADA",
                                textTransform: "none",
                                px: 3,
                              }}
                              onClick={() =>
                                handleSaveModuleGstToggle(
                                  item.key,
                                  item.checked,
                                )
                              }
                            >
                              Save
                            </Button>
                          )}
                        </Box>
                      ))}
                    </FormGroup>
                  </Box>
                </Paper>
              </>
            )}

            {mainTab === 11 && (
              <>
                <Paper
                  elevation={2}
                  sx={{ p: 3, width: "100%", border: "1px solid #ccc" }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    Look Book
                  </Typography>
                  {/*Look Book  Texfield and Button */}
                  <Grid container spacing={2}>
                    <TextField
                      size="small"
                      fullWidth
                      //label="Look Book "
                      // placeholder="Enter Look Book Here"
                      value={lookbookText}
                      onChange={(e) => setLookbookText(e.target.value)}
                    />
                  </Grid>
                  {/* add button */}
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onClick={handelLookBook}
                    >
                      Add
                    </Button>
                  )}
                </Paper>
              </>
            )}

            {mainTab === 12 && (
              <Paper
                elevation={2}
                sx={{ p: 3, width: "100%", border: "1px solid #ccc" }}
              >
                <Typography
                  fontWeight={700}
                  fontSize={24}
                  mb={3}
                  fontFamily={"Aeonik"}
                >
                  Mode
                </Typography>

                <Grid item xs={20}>
                  <FormControl fullWidth size="small">
                    <InputLabel>{t("appConfig.selectOption")}</InputLabel>
                    <Select
                      // value={unitType}
                      // onChange={(e) => setUnitType(e.target.value)}
                      label={t("appConfig.selectOption")}
                      value={appMode}
                      onChange={(e) => setAppMode(e.target.value)}
                    >
                      <MenuItem value="">{t("appConfig.selectMode")}</MenuItem>
                      <MenuItem value="PROD">PROD</MenuItem>
                      <MenuItem value="TEST">TEST</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {(canCreateSetting || canEdit) && (
                  <Button
                    variant="contained"
                    sx={{
                      bgcolor: "#752ADA",
                      px: 6,
                      textTransform: "none",
                      mt: 3,
                    }}
                    onClick={handelAppMode}
                  >
                    Add
                  </Button>
                )}
              </Paper>
            )}

            {/* GST  */}
            {/* {mainTab === 13  && (
                
                <Reusable
                label={t("appConfig.controlAllFeature")}
                options={Object.values(featuresData)}
                selected={featureToggle}
                onChange={setFeatureToggle}
                onSave={() =>
                  dispatch(
                    updateConfigRequest({
                      key: "featureToggle",
                      value: featureToggle,
                    })
                  )
                }
                showButton={canCreateSetting || canEdit}
              />
              )} */}

            {mainTab === 13 && (
              <>
                <Paper
                  elevation={2}
                  sx={{ p: 3, width: "100%", border: "1px solid #ccc" }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    Terms & Condition
                  </Typography>
                  {/*Look Book  Texfield and Button */}
                  <Grid container spacing={2}>
                    <TextField
                      size="small"
                      fullWidth
                      label={t("appConfig.termsAndCondition")}
                      placeholder={t("appConfig.enterTermsAndConditionHere")}
                      value={termsAndConditionsUrl}
                      onChange={(e) => setTermsAndConditionsUrl(e.target.value)}
                      multi={true}
                    />
                  </Grid>
                  {/* add button */}
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onClick={handleTermsAndConditionsUrl}
                    >
                      Add
                    </Button>
                  )}
                </Paper>
              </>
            )}

            {mainTab === 14 && (
              <>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    Show Calculation Amount in Redeem
                  </Typography>

                  <FormGroup row sx={{ color: "#7B8499" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={showCalculatedAmountInRedeem}
                          onChange={(e) =>
                            setShowCalculatedAmountInRedeem(e.target.checked)
                          }
                          sx={{
                            color: "#7b8499",
                            "&.Mui-checked": {
                              color: "#4caf50",
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          variant="body2"
                          fontFamily={"Inter"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          color="#7b8499"
                        >
                          Enable
                        </Typography>
                      }
                    />
                  </FormGroup>

                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onClick={handleSaveShowCalculatedAmountInRedeem}
                    >
                      Save
                    </Button>
                  )}
                </Paper>
              </>
            )}

            {mainTab === 15 && (
              <>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    Referral Required While Registration
                  </Typography>

                  <FormGroup row sx={{ color: "#7B8499" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={referralRequiredRegistration}
                          onChange={(e) =>
                            setReferralRequiredRegistration(e.target.checked)
                          }
                          sx={{
                            color: "#7b8499",
                            "&.Mui-checked": {
                              color: "#4caf50",
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          variant="body2"
                          fontFamily={"Inter"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          color="#7b8499"
                        >
                          Enable
                        </Typography>
                      }
                    />
                  </FormGroup>

                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onClick={handleSaveReferralRequiredRegistration}
                    >
                      Save
                    </Button>
                  )}
                </Paper>
              </>
            )}
            
            {mainTab === 16 && (
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  width: "100%",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                }}
              >
                <Typography
                  fontWeight={700}
                  fontSize={22}
                  mb={3}
                  fontFamily={"Aeonik"}
                >
                  App Links
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    maxWidth: 800,
                  }}
                >
                  <TextField
                    fullWidth
                    size="small"
                    label="Android App Link"
                    placeholder="Android App Link"
                    value={appLinks.androidAppLink}
                    onChange={(e) =>
                      setAppLinks({
                        ...appLinks,
                        androidAppLink: e.target.value,
                      })
                    }
                  />

                  <TextField
                    fullWidth
                    size="small"
                    label="iOS App Link"
                    placeholder="iOS App Link"
                    value={appLinks.iosAppLink}
                    onChange={(e) =>
                      setAppLinks({ ...appLinks, iosAppLink: e.target.value })
                    }
                  />

                  <TextField
                    fullWidth
                    size="small"
                    label="One Link"
                    placeholder="One Link"
                    value={appLinks.oneLink}
                    onChange={(e) =>
                      setAppLinks({ ...appLinks, oneLink: e.target.value })
                    }
                  />
                </Box>

                {(canCreateSetting || canEdit) && (
                  <Button
                    variant="contained"
                    sx={{
                      bgcolor: "#752ADA",
                      px: 6,
                      textTransform: "none",
                      mt: 3,
                    }}
                    onClick={handleSaveAppLinks}
                  >
                    Save
                  </Button>
                )}
              </Paper>
            )}

            {mainTab === 17 && (
              <>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    mb={3}
                    fontFamily={"Aeonik"}
                  >
                    Enable Customer Middle Name
                  </Typography>

                  <FormGroup row sx={{ color: "#7B8499" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={middleNameEnabled}
                          onChange={(e) =>
                            setMiddleNameEnabled(e.target.checked)
                          }
                          sx={{
                            color: "#7b8499",
                            "&.Mui-checked": {
                              color: "#4caf50",
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          variant="body2"
                          fontFamily={"Inter"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          color="#7b8499"
                        >
                          Enable
                        </Typography>
                      }
                    />
                  </FormGroup>

                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onClick={handleSaveMiddleName}
                    >
                      Save
                    </Button>
                  )}
                </Paper>
              </>
            )}

            {mainTab === 17 && (
              <Paper
                elevation={2}
                sx={{ p: 3, width: "100%", border: "1px solid #ccc" }}
              >
                <Typography
                  fontWeight={700}
                  fontSize={24}
                  mb={3}
                  fontFamily={"Aeonik"}
                >
                  Ofline Payment Type
                </Typography>

                <FormGroup row sx={{ color: "#7B8499" }}>
                  {[
                    { key: "home", label: "Home" },
                    { key: "store", label: "Store" },
                  ].map(({ key, label }) => (
                    <FormControlLabel
                      key={key}
                      control={
                        <Checkbox
                          checked={offlinePaymentType[key] === true}
                          onChange={(event) =>
                            setOfflinePaymentType((currentTypes) => ({
                              ...currentTypes,
                              [key]: event.target.checked,
                            }))
                          }
                          sx={{
                            color: "#7b8499",
                            "&.Mui-checked": {
                              color: "#4caf50",
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          variant="body2"
                          fontFamily="Inter"
                          fontSize="14px"
                          fontWeight="500"
                          color="#7b8499"
                        >
                          {label}
                        </Typography>
                      }
                    />
                  ))}
                </FormGroup>

                {(canCreateSetting || canEdit) && (
                  <Button
                    variant="contained"
                    sx={{
                      bgcolor: "#752ADA",
                      px: 6,
                      textTransform: "none",
                      mt: 3,
                    }}
                    onClick={handleSaveOfflinePaymentType}
                  >
                    Add
                  </Button>
                )}
              </Paper>
            )}

            {mainTab === 18 && (
              <>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                >
                  {(canCreateSetting || canEdit) && (
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#752ADA",
                        px: 6,
                        textTransform: "none",
                        mt: 3,
                      }}
                      onClick={handleAutoDebit}
                    >
                      Save
                    </Button>
                  )}
                </Paper>
              </>
            )}

            {mainTab === 19 && (
              <Paper
                elevation={2}
                sx={{ p: 3, width: "100%", border: "1px solid #ccc" }}
              >
                <Typography
                  fontWeight={700}
                  fontSize={24}
                  mb={1}
                  fontFamily={"Aeonik"}
                >
                  Jeweller App Status
                </Typography>
                <Typography
                  fontSize={14}
                  color="text.secondary"
                  mb={3}
                  fontFamily={"Aeonik"}
                >
                  Turn iOS or Android on or off. Saving one platform keeps the other as it is.
                </Typography>
                <FormGroup row sx={{ color: "#7B8499", gap: 4 }}>
                  {[
                    { key: "ios", label: "iOS" },
                    { key: "android", label: "Android" },
                  ].map(({ key, label }) => (
                    <FormControlLabel
                      key={key}
                      control={
                        <Switch
                          checked={jewellerAppStatus[key] === true}
                          disabled={!(canCreateSetting || canEdit)}
                          onChange={(event) =>
                            handleJewellerAppStatus(key, event.target.checked)
                          }
                          sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: "#752ADA",
                            },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                              {
                                backgroundColor: "#752ADA",
                              },
                          }}
                        />
                      }
                      label={
                        <Typography
                          variant="body2"
                          fontFamily="Inter"
                          fontSize="14px"
                          fontWeight="600"
                          color="#333"
                        >
                          {label}
                        </Typography>
                      }
                    />
                  ))}
                </FormGroup>
              </Paper>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AppConfig;
